import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}
import { computed } from "vue";

export interface StepperItem {
  key: string;
  label: string;
}

interface Props {
  steps: StepperItem[];
  current: string;
}

// Sichtbarer Fortschritt des Checkouts: 1 Kurs, 2 Wer bucht, 3 Angaben, 4 Pruefen, 5 Fertig
export default {
  template: html,
  props: {
    steps: {
      type: Array,
      required: true,
    },
    current: {
      type: String,
      required: true,
    },
  },
  setup(props: Props) {
    const items = computed(function () {
      const currentIndex = props.steps.findIndex((s) => s.key == props.current);
      return props.steps.map(function (s, i) {
        return {
          key: s.key,
          label: s.label,
          number: i + 1,
          state: i < currentIndex ? "done" : i == currentIndex ? "active" : "todo",
        };
      });
    });
    return { items };
  },
};
